// pages/AdminMessages.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';


const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    fetchMessages();
  }, []);

  const token = localStorage.getItem("adminToken");


  const fetchMessages = async () => {
    try {
      const response = await axios.get(
        // 'http://localhost:3005/api/messages'
        "https://afric-fresh-backend.onrender.com/api/messages"
        ,{
          headers: {
            Authorization: `Bearer ${token}`
          }},
    );
      setMessages(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching messages:', error);
      setLoading(false);
    }
  };

  const handleMessageClick = async (message) => {
    setSelectedMessage(message);
    if (!message.isRead) {
      try {
        await axios.put(
            // `http://localhost:3005/api/messages/${message._id}/mark-read`
            `https://afric-fresh-backend.onrender.com/api/messages/${message._id}/mark-read`
            ,{
              headers: {
                Authorization: `Bearer ${token}`
              }},);
        // Update local state
        setMessages(messages.map(msg => 
          msg._id === message._id ? { ...msg, isRead: true } : msg
        ));
      } catch (error) {
        console.error('Error marking message as read:', error);
      }
    }
  };

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Messages List */}
      <div className="w-1/3 bg-white border-r overflow-y-auto">
        <div className="p-4 border-b">
          <h2 className="text-xl font-semibold">Messages</h2>
        </div>
        {messages.map((message) => (
          <div
            key={message._id}
            onClick={() => handleMessageClick(message)}
            className={`p-4 border-b cursor-pointer hover:bg-gray-50 ${
              !message.isRead ? 'bg-blue-50' : ''
            } ${selectedMessage?._id === message._id ? 'bg-gray-100' : ''}`}
          >
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-medium">{message.name}</h3>
                <p className="text-sm text-gray-600 truncate">{message.message}</p>
              </div>
              <span className="text-xs text-gray-400">
                {format(new Date(message.createdAt), 'MMM d, yyyy')}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Message Detail */}
      <div className="flex-1 bg-white p-6">
        {selectedMessage ? (
          <div>
            <div className="mb-6">
              <h2 className="text-2xl font-bold mb-2">{selectedMessage.name}</h2>
              <div className="flex space-x-4 text-sm text-gray-500">
                <span>{selectedMessage.email}</span>
                <span>{selectedMessage.contact}</span>
                <span>{format(new Date(selectedMessage.createdAt), 'PPpp')}</span>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="whitespace-pre-wrap">{selectedMessage.message}</p>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500">
            Select a message to view details
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminMessages;